import React from "react";
import "./experience.css";
import { MdFactCheck } from "react-icons/md";

const Experience = () => {
  return (
    <section id="experience">
      <h5 className="center__heading">What Are My Skills?</h5>
      <h2 className="center__heading">Skills Listed</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <h3>Frontend Development</h3>
          <div className="experience__content">
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>HTML</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>CSS</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>JavaScript</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>Bootstrap</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>React</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>JQuery</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
          </div>
        </div>
        {/* END OF FRONTEND DEVELOPMENT */}
        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>Node.js</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>Insomnia</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>MongoDB</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience__bullets">
              <MdFactCheck className="experience__bullets-icon" />
              <div>
                <h4>MySQL</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
